<div ngModelGroup="comboTipoSangue-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboTipoSangue
                       nome="tipoSangue-{{data}}"
                       [itens]="dados"
                       itemDescricao="tipo"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Tipo de sangue"
                       label="Tipo de sangue"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
